// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { nexi as _nexi } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the nexi chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 4242
 * Chain Name: Nexi
 * Default Block Explorer: https://www.nexiscan.com
 * Default RPC URL: https://rpc.chain.nexi.technology
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { nexi } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: nexi,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const nexi = createCommon({
	..._nexi,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
